module.exports = __webpack_public_path__ + "img/dombornyomas-thumb.636ac423.jpg";